module.exports = __webpack_public_path__ + "static/img/success.1069ed0e.png";